import _extends from "@babel/runtime/helpers/extends";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useTabPanel } from '../hooks';

// Note this is not being memoized as children is an unstable reference
var TabPanel = function TabPanel(_ref) {
  var children = _ref.children,
      testId = _ref.testId;
  var tabPanelAttributes = useTabPanel();
  return jsx("div", _extends({
    "data-testid": testId
  }, tabPanelAttributes), children);
};

export default TabPanel;